import { createFileRoute } from "@tanstack/react-router";
import { SuggestionDetail } from "@/components/University/suggestions/SuggestionDetail";

function RouteComponent() {
  const { id } = Route.useParams();
  return <SuggestionDetail id={id} />;
}

export const Route = createFileRoute("/_authenticated/atlas/suggestions/$id")({
  component: RouteComponent,
  staticData: { page: "university" },
});
